/* Keep explicitly answered fit questions consistent between Kindred tools. */
(function (global) {
  'use strict';
  if (global.KindredFitState) {
    if (typeof document !== 'undefined') global.KindredFitState.mount(document);
    return;
  }

  var STORAGE_KEY = 'kindred-fit-state-v1';
  var ROOT_SELECTOR = '[data-custom-build-intake], [data-kindred-shape-size-advisor]';
  var KEYS = [
    'collection', 'ski_style', 'unit', 'height', 'height_feet', 'height_inches',
    'weight', 'boot_size_unit', 'boot_size', 'ability', 'location',
    'stance_width_unit', 'stance_width', 'front_angle', 'rear_angle',
    'ski_bsl', 'ski_binding_style', 'terrain', 'snow', 'turn_style',
    'responsiveness', 'ride_feel', 'touring_focus', 'ski_touring_notch', 'priorities'
  ];
  var memory = {};
  var storageUsable = true;
  var roots = [];

  function copy(value) { return JSON.parse(JSON.stringify(value)); }
  function allowed(key) { return KEYS.indexOf(key) !== -1; }
  function clean(source) {
    var result = {};
    if (!source || typeof source !== 'object' || Array.isArray(source)) return result;
    KEYS.forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(source, key)) return;
      var value = source[key];
      if (key === 'priorities') {
        if (Array.isArray(value)) result[key] = value.filter(function (item, index, values) {
          return typeof item === 'string' && item.length <= 120 && values.indexOf(item) === index;
        }).slice(0, 3);
      } else if ((typeof value === 'string' || typeof value === 'number') && String(value).length <= 120) {
        result[key] = String(value);
      }
    });
    if (result.unit && result.unit !== 'metric' && result.unit !== 'imperial') delete result.unit;
    return result;
  }
  function load() {
    if (!storageUsable) return copy(memory);
    try {
      var saved = global.sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        var payload = JSON.parse(saved);
        memory = payload && payload.version === 1 ? clean(payload.answers) : {};
      } else memory = {};
    } catch (error) { storageUsable = false; /* Session storage can be unavailable in private or embedded browsers. */ }
    return copy(memory);
  }
  function write(answers) {
    memory = clean(answers);
    try {
      global.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ version: 1, answers: memory }));
    } catch (error) { storageUsable = false; /* The in-page tools still share answers when storage is blocked. */ }
    return copy(memory);
  }
  function save(patch, options) {
    var answers = load();
    var sanitized = clean(patch);
    Object.keys(sanitized).forEach(function (key) { answers[key] = sanitized[key]; });
    KEYS.forEach(function (key) {
      if (patch && Object.prototype.hasOwnProperty.call(patch, key) && patch[key] === null) delete answers[key];
    });
    var saved = write(answers);
    roots = roots.filter(function (root) { return root.isConnected; });
    roots.forEach(function (root) {
      if (!options || root !== options.source) restore(root, saved);
    });
    return saved;
  }

  function fields(root, key) {
    return Array.prototype.filter.call(root.querySelectorAll('input, select, textarea'), function (field) {
      if (field.getAttribute('data-advisor-field') === key || field.getAttribute('data-field') === key) return true;
      var question = field.closest('[data-question-key]');
      return question && question.getAttribute('data-question-key') === key &&
        (field.type === 'radio' || field.type === 'checkbox');
    });
  }
  function fieldKey(field) {
    var key = field.getAttribute('data-advisor-field') || field.getAttribute('data-field');
    if (!key && (field.type === 'radio' || field.type === 'checkbox')) {
      var question = field.closest('[data-question-key]');
      if (question) key = question.getAttribute('data-question-key');
    }
    return allowed(key) ? key : '';
  }
  function available(field, root) {
    if (field.disabled) return false;
    for (var node = field.parentElement; node && node !== root; node = node.parentElement) {
      // Wizard steps can be hidden without disabling their questionnaire answers.
      if (node.hidden && !node.hasAttribute('data-step') && !node.hasAttribute('data-advisor-step')) return false;
    }
    return true;
  }
  function read(root, key) {
    var group = fields(root, key);
    if (!group.length) return '';
    if (group[0].type === 'checkbox') return group.filter(function (field) { return field.checked && available(field, root); }).map(function (field) { return field.value; });
    if (group[0].type === 'radio') {
      var checked = group.filter(function (field) { return field.checked && available(field, root); })[0];
      return checked ? checked.value : '';
    }
    return group[0].value;
  }
  function dispatch(field, type) {
    field.dispatchEvent(new global.Event(type || 'change', { bubbles: true }));
  }
  function selectedCollection(root) {
    return fields(root, 'collection').filter(function (field) { return field.checked; })[0];
  }
  function applyField(root, key, value, answers) {
    var group = fields(root, key);
    if (!group.length) return;
    if (group[0].type === 'radio') {
      if (value === '') {
        var previous = group.filter(function (field) { return field.checked; })[0];
        if (previous) { previous.checked = false; dispatch(previous); }
        return;
      }
      var match = group.filter(function (field) {
        return field.value === String(value) && available(field, root) &&
          (key !== 'collection' || value !== 'ski' || !answers.ski_style || field.getAttribute('data-ski-style') === answers.ski_style);
      })[0];
      // A product tool may support only some collections or touring formats.
      if (!match || match.checked) return;
      group.forEach(function (field) { field.checked = field === match; });
      dispatch(match);
      return;
    }
    if (group[0].type === 'checkbox') {
      var values = Array.isArray(value) ? value : [];
      var changed = [];
      group.forEach(function (field) {
        var checked = available(field, root) && values.indexOf(field.value) !== -1;
        if (field.checked !== checked) { field.checked = checked; changed.push(field); }
      });
      var hasSelection = group.some(function (field) { return field.checked; });
      if (changed.length) dispatch(changed[changed.length - 1], hasSelection || root.matches('[data-kindred-shape-size-advisor]') ? 'change' : 'input');
      return;
    }
    var field = group[0];
    if (!available(field, root)) return;
    if (field.tagName === 'SELECT' && !Array.prototype.some.call(field.options, function (option) { return option.value === String(value) && !option.disabled; })) return;
    if (field.value === String(value)) return;
    field.value = String(value);
    dispatch(field, 'input');
    dispatch(field);
  }
  function ready(root) {
    if (root.matches('[data-kindred-shape-size-advisor]')) return root.getAttribute('data-kindred-advisor-ready') === 'true';
    return Boolean(root._kcbConfig && root.classList.contains('is-enhanced'));
  }
  function restore(root, supplied) {
    if (!root || !root.matches || !root.matches(ROOT_SELECTOR) || !ready(root)) return false;
    var state = root._kindredFitState;
    if (!state) { mountOne(root); state = root._kindredFitState; }
    if (state.restoring) return false;
    var answers = supplied ? clean(supplied) : load();
    state.restoring = true;
    try {
      if (answers.unit && answers.unit !== (root.getAttribute('data-units') || 'metric')) {
        var unitButton = root.querySelector('[data-unit="' + answers.unit + '"]');
        if (unitButton) unitButton.click();
      }
      // Collection determines the available ride goals. Units determine measurement controls.
      if (Object.prototype.hasOwnProperty.call(answers, 'collection')) applyField(root, 'collection', answers.collection, answers);
      ['boot_size_unit', 'stance_width_unit'].forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(answers, key)) applyField(root, key, answers[key], answers);
      });
      KEYS.forEach(function (key) {
        if (['unit', 'collection', 'ski_style', 'boot_size_unit', 'stance_width_unit'].indexOf(key) !== -1) return;
        if (Object.prototype.hasOwnProperty.call(answers, key)) applyField(root, key, answers[key], answers);
      });
    } finally { state.restoring = false; }
    return true;
  }
  function resetQuestions(root) {
    var state = root._kindredFitState;
    if (!state || !ready(root)) return;
    state.restoring = true;
    try {
      var metric = root.querySelector('[data-unit="metric"]');
      if (metric && root.getAttribute('data-units') !== 'metric') metric.click();
      KEYS.forEach(function (key) {
        fields(root, key).forEach(function (field) {
          if (field.type === 'radio' || field.type === 'checkbox') field.checked = false;
          else if (field.tagName === 'SELECT') field.selectedIndex = 0;
          else field.value = field.type === 'hidden' ? field.defaultValue : '';
        });
      });
      // One collection change refreshes conditional questions and discards outdated suggestions.
      var collection = fields(root, 'collection')[0];
      if (collection) dispatch(collection);
      var height = fields(root, 'height')[0];
      if (height) dispatch(height, 'input');
    } finally { state.restoring = false; }
  }
  function clear(options) {
    memory = {};
    try { global.sessionStorage.removeItem(STORAGE_KEY); } catch (error) { storageUsable = false; /* Optional persistence. */ }
    roots.forEach(function (root) { if (!options || root !== options.source) resetQuestions(root); });
  }
  function capture(root, target) {
    var key = fieldKey(target);
    if (!key || (target.type === 'radio' && !target.checked)) return;
    var patch = {};
    patch[key] = read(root, key);
    if (['height', 'height_feet', 'height_inches', 'weight'].indexOf(key) !== -1) patch.unit = root.getAttribute('data-units') || 'metric';
    if (key === 'boot_size') patch.boot_size_unit = read(root, 'boot_size_unit');
    if (key === 'stance_width') patch.stance_width_unit = read(root, 'stance_width_unit');
    if (key === 'collection') {
      var collection = selectedCollection(root);
      patch.ski_style = collection && collection.value === 'ski' ? collection.getAttribute('data-ski-style') || '' : '';
      // Do not retain an answer that the collection change made invalid.
      var answers = load();
      ['terrain', 'snow', 'priorities', 'touring_focus', 'ski_touring_notch'].forEach(function (question) {
        if (Object.prototype.hasOwnProperty.call(answers, question)) patch[question] = read(root, question);
      });
    }
    save(patch, { source: root });
  }
  function mountOne(root) {
    if (root._kindredFitState) return;
    var state = root._kindredFitState = { restoring: false, hydrated: false };
    roots.push(root);
    function hydrate() {
      if (state.hydrated || !ready(root)) return;
      state.hydrated = true;
      if (state.observer) { state.observer.disconnect(); state.observer = null; }
      restore(root);
    }
    ['input', 'change'].forEach(function (type) {
      root.addEventListener(type, function (event) {
        // Calculated defaults and our own restore events are never recorded as answers.
        if (!event.isTrusted || state.restoring || !ready(root) || !event.target || !event.target.matches('input, select, textarea')) return;
        capture(root, event.target);
      });
    });
    root.addEventListener('click', function (event) {
      if (!event.isTrusted || state.restoring || !event.target || !event.target.closest) return;
      var reset = event.target.closest('[data-start-over], [data-advisor-start-over]');
      if (reset && root.contains(reset)) { clear({ source: root }); return; }
      var unit = event.target.closest('[data-unit]');
      if (!unit || !root.contains(unit)) return;
      var answers = load();
      var patch = { unit: root.getAttribute('data-units') || 'metric' };
      if (['height', 'height_feet', 'height_inches'].some(function (key) { return Object.prototype.hasOwnProperty.call(answers, key); })) {
        ['height', 'height_feet', 'height_inches'].forEach(function (key) { patch[key] = read(root, key); });
      }
      ['weight', 'stance_width', 'stance_width_unit'].forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(answers, key)) patch[key] = read(root, key);
      });
      save(patch, { source: root });
    });
    root.addEventListener('kindred.advisor.ready', hydrate);
    if (global.MutationObserver) {
      state.observer = new global.MutationObserver(function () { global.setTimeout(hydrate, 0); });
      state.observer.observe(root, { attributes: true, attributeFilter: ['class', 'data-kindred-advisor-ready'] });
    }
    global.setTimeout(hydrate, 0);
  }
  function mount(scope) {
    if (typeof document === 'undefined') return;
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches(ROOT_SELECTOR)) mountOne(context);
    Array.prototype.forEach.call(context.querySelectorAll(ROOT_SELECTOR), mountOne);
  }
  global.KindredFitState = { version: 1, storageKey: STORAGE_KEY, save: save, load: load, clear: clear, restore: restore, mount: mount };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
    else mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
